export const breakpoints = {
  largeMobile: 420,
  tablet: 768,
  tabletLandscape: 1024,
  laptop: 1280,
  desktop: 1440,
  wide: 1600,
  fullHd: 1920
};

export const weatherIconMap = {
  snow_heavy: 'heavy-snow',
  snow: 'heavy-snow',
  wind: 'wind',
  overcast: 'clouds',
  cloud3: 'clouds',
  cloudy: 'clouds',
  freezing_rain: 'hail',
  sunny_with_haze: 'sun-lines',
  rain_heavy: 'rain-heavy',
  sleet_showers: 'hail',
  cloudy_partly_rain: 'rain-light',
  cloudy_partly_snow: 'light-snow',
  thunderstorm_occasional: 'lightning',
  snow_light: 'light-snow',
  cloudy_mostly: 'day-cloudy',
  sunny_mostly: 'sun-lines',
  thunderstorm_showers: 'lightning',
  sleet: 'hail',
  sunny_few_clouds: 'day-cloudy',
  dust: 'wind',
  fog: 'fog',
  cloudy_mostly_snow: 'light-snow',
  rain: 'rain-light',
  cloudy_mostly_rain: 'rain-light',
  rain_occasional: 'rain-light',
  sunny: 'sun',
  cloudy_partly: 'day-cloudy',
  freezing_drizzle: 'hail',
  freezing_spray: 'hail',
  interrupting_sleet_snow: 'hail',
  isolated_freezing_drizzle: 'hail',
  isolated_freezing_rain: 'hail',
  isolated_sleet: 'hail',
  isolated_sleet_sno: 'hail',
  light_sleet: 'hail',
  light_sleet_snow: 'hail',
  occasional_freezing_drizzle: 'hail',
  occasional_freezing_rain: 'hail',
  occasional_winter_mix: 'hail',
  patchy_freezing_drizzle: 'hail',
  patchy_sleet_snow: 'hail',
  patchy_wintry_mix: 'hail',
  periods_of_freezing_drizzle: 'hail',
  periods_of_freezing_rain: 'hail',
  periods_of_sleet: 'hail',
  scattered_freezing_drizzle: 'hail',
  scattered_freezing_rain: 'hail',
  scattered_sleet: 'hail',
  scattered_sleet_snow: 'hail',
  sleet_snow: 'hail',
  widespread_freezing_drizzle: 'hail',
  widespread_rain_showers: 'hail',
  widespread_wintry_mix: 'hail',
  hazy: 'fog',
  interrupting_snow: 'light-snow',
  light_snow: 'light-snow',
  occasional_snow: 'light-snow',
  occasional_snow_showers: 'light-snow',
  periods_of_snow: 'light-snow',
  snow_flurries: 'light-snow',
  frequent_snow_showers: 'heavy-snow',
  heavy_snow: 'heavy-snow',
  isolated_snow_showers: 'heavy-snow',
  numerous_snow_showers: 'heavy-snow',
  patchy_blowing_snow: 'heavy-snow',
  periods_of_snow_showers: 'heavy-snow',
  scattered_blowing_snow: 'heavy-snow',
  scattered_snow_showers: 'heavy-snow',
  snow_scattered_showers: 'heavy-snow',
  snow_showers: 'heavy-snow',
  widespread_snow_showers: 'heavy-snow',
  mostly_cloudy: 'day-cloudy',
  partly_cloudy: 'day-cloudy',
  patchy_fog: 'fog',
  patchy_freezing_fog: 'fog',
  patchy_ice_fog: 'fog',
  scattered_fog: 'fog',
  scattered_freezing_fog: 'fog',
  scattered_ice_fog: 'fog',
  widespread_fog: 'fog',
  widespread_freezing_fog: 'fog',
  isolated_storms: 'lightning',
  isolated_thunderstorms: 'lightning',
  numerous_storms: 'lightning',
  numerous_thunderstorms: 'lightning',
  occasional_thunderstorms: 'lightning',
  scattered_storms: 'lightning',
  scattered_thunderstorms: 'lightning',
  storms: 'lightning',
  thunderstorms: 'lightning',
  widespread_storms: 'lightning',
  patchy_frost: 'fog',
  scattered_frost: 'fog',
  drizzle: 'rain-heavy',
  heavy_rain: 'rain-heavy',
  heavy_showers: 'rain-heavy',
  interrupting_drizzle: 'rain-heavy',
  isolated_drizzle: 'rain-heavy',
  isolated_showers: 'rain-heavy',
  numerous_showers: 'rain-heavy',
  occasional_showers: 'rain-heavy',
  patchy_drizzle: 'rain-heavy',
  periods_of_drizzle: 'rain-heavy',
  periods_of_showers: 'rain-heavy',
  rain_showers: 'rain-heavy',
  scattered_showers: 'rain-heavy',
  scattered_water_spouts: 'rain-heavy',
  showers: 'rain-heavy',
  widespread_drizzle: 'rain-heavy',
  widespread_showers: 'rain-heavy',
  light_drizzle: 'rain-light',
  light_rain: 'rain-light',
  occasional_drizzle_: 'rain-light',
  occasional_rain: 'rain-light',
  periods_of_rain: 'rain-light',
  scattered_drizzle: 'rain-light',
  mostly_sunny: 'sun-lines',
  mostlysunny: 'sun-lines',
  blowing_snow: 'blowingsnow',
  patchy_blowing_dust: 'wind',
  patchy_smoke: 'wind',
  scattered_blowing_dust: 'wind',
  scattered_smoke: 'wind',
  smoke: 'wind',
  isolated_wintry_mix: 'wintery-mix',
  numerous_wintry_mix: 'wintery-mix',
  periods_of_wintry_mix: 'wintery-mix',
  scattered_wintry_mix: 'wintery-mix',
  wintry_mix: 'wintery-mix',
  rainsnow: 'wintery-mix',
  lightrainsnow: 'wintery-mix',
  thundersnow: 'lightning',
  scatteredthunderstorms: 'lightning',
  snowshowers: 'light-snow',
  partlycloudy: 'day-cloudy',
  mostlycloudy: 'clouds',
  windy: 'wind',
  blizzard: 'heavy-snow',
  rainshowers: 'rain-heavy',
  hot: 'summer',
  cold: ''
};

export const RUN_ANIMATION_KEY = 'run_homepage_animation';

export const customEvents = {
  closeMobilePrimaryNavTrigger: 'close-mobile-primary-nav-trigger',
  closeWeatherWidgetTrigger: 'close-weather-widget-trigger',
  leftBorderResizeTrigger: 'left-border-resize-trigger'
};
